import ClientAccessCard from "../components/ui/ClientAccessCard.jsx";
import styles from "./ProjectsRepoPage.module.css";

const DELIVERABLES = [
  "Ficha técnica",
  "Manual de operación",
  "Planos y esquemáticos",
  "Cronograma Gantt en vivo",
  "Documentos logísticos",
];

export default function ProjectsRepoPage() {
  return (
    <section className={styles.wrap} aria-label="Repositorio y seguimiento de proyectos">
      <div className={styles.layout}>
        <div className={styles.main}>
          <header className={styles.head}>
            <span className="mono-tag">↳ repositorio & trazabilidad</span>
            <h2 className={styles.h1}>
              Máquinas, planos y manuales —<br />
              <span className={styles.alt}>la documentación de su proyecto.</span>
            </h2>
            <p className={styles.lead}>
              Cada equipo que diseñamos queda documentado de principio a fin.
              Acceda al repositorio técnico de sus equipos y consulte el avance
              en tiempo real iniciando sesión como cliente.
            </p>
            <ul className={styles.pills} aria-label="Entregables incluidos">
              {DELIVERABLES.map((item) => (
                <li key={item} className={styles.pill}>
                  <span className={styles.pillDot} />
                  {item}
                </li>
              ))}
            </ul>
          </header>
        </div>

        <aside className={styles.sidebar}>
          <ClientAccessCard />
        </aside>
      </div>
    </section>
  );
}
